const loggerMiddleware = () => (next: any) => (action: any) => {
  const sanitizedAction = { ...action };

  if (sanitizedAction.payload && sanitizedAction.payload.auth) {
    sanitizedAction.payload = {
      ...sanitizedAction.payload,
      auth: {
        ...sanitizedAction.payload.auth,
        token: '***',
      },
    };
  }

  if (import.meta.env.DEV) {
    console.log('[LOGGER]', sanitizedAction);
  }
  return next(action);
};

export default loggerMiddleware;
